import "../sellscreendialogs.scss";
import { type FC, useCallback } from "react";
import { useShopfrontDispatch } from "../../../../_Bootstrap/hooks";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import {
    type GiftCardPayment,
    requestPayGiftCard,
    type SaleAddPaymentOptions,
} from "../../../../Actions/SellScreen/SellScreenPaymentActions";
import Button from "../../../../Common/Buttons/Button";
import Currency from "../../../../Common/Misc/Currency";

export const RequestSelectGiftCard: FC<{
    method: string;
    amount: number;
    options: SaleAddPaymentOptions;
    code: string;
    found: Array<GiftCardPayment>;
}> = ({
    method,
    amount,
    options,
    code,
    found,
}) => {
    const dispatch = useShopfrontDispatch();

    const addCard = useCallback((giftCard: GiftCardPayment) => {
        dispatch(requestPayGiftCard(
            method,
            amount,
            {
                ...options,
                giftcard: giftCard,
            }
        ));
    }, [ amount, dispatch, method, options ]);

    return (
        <div className="request-select-gift-card">
            <span>Code: {code}</span>
            <div className="gift-cards">
                {found.map((giftCard) => {
                    return (
                        <div
                            key={giftCard.id}
                            className="gift-card-line"
                            onClick={() => addCard(giftCard)}
                        >
                            <div className="balance">
                                <div className="original">
                                    Original: <Currency value={giftCard.original_amount} />
                                </div>
                                <div className="current">
                                    Current: <Currency value={giftCard.current_amount} />
                                </div>
                            </div>
                            <div className="expiry">Expiry: {giftCard.expiry}</div>
                        </div>
                    );
                })}
            </div>
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    onClick={() => dispatch(hideDialog())}
                >
                    Cancel
                </Button>
            </div>
        </div>
    );
};
